var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"pl-6 pr-6 pt-8 container"},[_c('p',{staticClass:"card-title mb-8"},[_vm._v("Test Component")]),_c('v-card',{staticClass:"table-wrapper elevation-0"},[_c('SelectedCustomers',{ref:"childComponent"})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }